import { defineTemplate } from '../../../utils';

const BASE = `${process.env.REACT_APP_MEDIA_DOMAIN}/brands/assets/DISNEY/templates`;

export const disneyCast = defineTemplate({
  mode: 'legacy',
  id: 'cast',
  clientId: 'DISNEY',
  handlerKey: 'DISNEY',
  title: 'Elenco',
  disabled: true,
  hiddenFromUI: true,
  thumbnail: {
    url: `${BASE}/thumbnails/elenco.png`,
    optimizedUrl: `${BASE}/thumbnails/optimized/elenco.png`,
    hoverVideo: `${BASE}/previews/grandes_elencos.mp4`,

    aspectRatio: 'vertical'
  },
  formFields: []
});
